import React from 'react';
import { Button } from './ui/button';
import './ServicesSection.css';

const ServicesSection = () => {
  const services = [
    {
      name: 'SIGNATURE CUT',
      description: 'A precision haircut tailored to your head shape, structure, and personal direction.',
      bookingUrl: 'https://www.fresha.com/book-now/the-lodge-inside-salon-rose-d5hpq959/services?lid=1341811&eid=3083627&oiid=sv%3A17953602&share=true&pId=1274239'
    },
    {
      name: 'SHORT CUT',
      description: 'A clean, minimal cut with sharp structure and controlled finishing.',
      bookingUrl: 'https://www.fresha.com/book-now/the-lodge-inside-salon-rose-d5hpq959/services?lid=1341811&eid=3083627&oiid=sv%3A17953601&share=true&pId=1274239'
    },
    {
      name: 'SHORT CUT + LINE UP',
      description: 'A short cut finished with a precisely defined hairline.',
      bookingUrl: 'https://www.fresha.com/book-now/the-lodge-inside-salon-rose-d5hpq959/services?lid=1341811&eid=3083627&oiid=sv%3A17953600&share=true&pId=1274239'
    },
    {
      name: 'SIGNATURE CUT + BEARD',
      description: 'A complete haircut paired with structured beard shaping and detailing.',
      bookingUrl: 'https://www.fresha.com/book-now/the-lodge-inside-salon-rose-d5hpq959/services?lid=1341811&eid=3083627&oiid=sv%3A17956810&share=true&pId=1274239'
    },
    {
      name: 'SHORT CUT + BEARD',
      description: 'A short cut combined with precise beard work and clean definition.',
      bookingUrl: 'https://www.fresha.com/book-now/the-lodge-inside-salon-rose-d5hpq959/services?lid=1341811&eid=3083627&oiid=sv%3A17956820&share=true&pId=1274239'
    },
    {
      name: 'TAPER',
      description: 'A gradual taper with disciplined blending and clean transitions.',
      bookingUrl: 'https://www.fresha.com/book-now/the-lodge-inside-salon-rose-d5hpq959/services?lid=1341811&eid=3083627&oiid=sv%3A17956792&share=true&pId=1274239'
    },
    {
      name: 'BEARD',
      description: 'Beard sculpting, shaping, and clean finishing with balanced proportions.',
      bookingUrl: 'https://www.fresha.com/book-now/the-lodge-inside-salon-rose-d5hpq959/services?lid=1341811&eid=3083627&oiid=sv%3A17956832&share=true&pId=1274239'
    }
  ];

  return (
    <section id="services" className="services-section">
      <div className="services-container">
        <h2 className="services-title">SERVICES</h2>
        <div className="divider-center"></div>
        
        <div className="services-grid">
          {services.map((service, index) => (
            <a 
              key={index} 
              href={service.bookingUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="service-item"
            >
              <h3 className="service-name">{service.name}</h3>
              <p className="service-description">{service.description}</p>
            </a>
          ))}
        </div>

        <div className="services-cta">
          <Button 
            className="services-book-button"
            onClick={() => window.open('https://www.fresha.com/book-now/the-lodge-inside-salon-rose-d5hpq959/all-offer?share=true&pId=1274239', '_blank')}
          >
            BOOK YOUR VISIT
          </Button>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;